import React from 'react';
import { Mic } from 'lucide-react';
import { useMeetingRecorder } from './MeetingRecorderContext';

// Bouton micro de la barre de navigation : ouvre « Enregistrer une réunion » depuis n'importe quelle page.
export const MeetingRecordButton = () => {
  const { phase, openDialog } = useMeetingRecorder();
  const recording = phase === 'recording' || phase === 'starting';
  return (
    <button
      type="button"
      onClick={() => openDialog()}
      disabled={recording}
      title={recording ? 'Réunion en cours d’enregistrement' : 'Enregistrer une réunion'}
      aria-label="Enregistrer une réunion"
      className={`relative rounded-full p-2 transition ${
        recording ? 'text-rose-600' : 'text-gray-500 hover:bg-gray-100 hover:text-rose-600'}`}
    >
      <Mic className="h-5 w-5" />
      {recording && <span className="absolute right-1 top-1 h-2 w-2 animate-pulse rounded-full bg-rose-600" />}
    </button>
  );
};

export default MeetingRecordButton;
